export default __webpack_public_path__ + "static/1920-310a2ccdcf77262878bc0bd12c3516ab.gif";